module.exports = __webpack_public_path__ + "static/media/інноваційні-системи-та-технології-зерносушарок.30216853.jpg";